/**
 * Imports
 */
import './styles/main.scss';
import './styles/home.scss';
import { gsap } from "gsap";
import './world/world';
import { Home } from './pages/Home.js'
import { MainLoader } from './pages/Loader.js'


var mouse = {
    x: undefined,
    y: undefined
}
/**
 * Main App
 */
let app = document.querySelector('#app');
let loader = document.getElementById('loader');
loader.innerHTML = MainLoader;
app.innerHTML = Home;
let cursor = document.getElementById('cursor');
let follower = document.getElementById('follower');
/**
 * Progress Bar
 */
let datacontainer = document.querySelector('.data');
let progress = datacontainer.dataset.progress;
progress = parseInt(progress);
let id = setInterval(() => {
    if (progress < 100) {
        datacontainer.dataset.progress = progress + 5 + '%';
        progress = progress + 5
    }
    else {
        clearInterval(id);
        loader.style.transform = `translateY(-100%)`;
        animateIn();
    }
}, 50);



/**
 * Cursor
 */
window.addEventListener('mousemove', customCursor, false);

function customCursor(e) {
    mouse.x = e.clientX;
    mouse.y = e.clientY;
    if (mouse && window.innerWidth>600) {
        cursor.style.display = 'block';
        cursor.style.transform = `translate(${mouse.x - 30}px,${mouse.y - 30}px)`;
        follower.style.display = 'block';
        gsap.to('#follower', {
            x: mouse.x - 65,
            y: mouse.y - 60,
            duration: 0.5,
        })
    }else{
        cursor.style.display = 'none';
        follower.style.display = 'none';
    }
}


/**
 * GSAP
 */
function animateIn() {
    setTimeout(()=>{
        gsap.to('.navlinks',{
            y:'0%',
            duration:0.8,
            stagger:0.2
        });
        gsap.to('.main',{
            opacity:1,
            duration:0.8,
            ease:'easeIn'
        });
    },800);
}



//Fellow Devs

console.log('%cHey there fellow developer!', 'font-size: 14px; color: #A52A2A; font-weight: 700; font-family: "Cinzel", Arial, sans-serif;');
console.log('%cLibraries I used :', 'font-size: 14px; color: #A52A2A; font-family: "Cinzel", Arial, sans-serif;');
console.log('%c => THREE JS', 'font-size: 14px; color: #A52A2A; font-family: "Cinzel", Arial, sans-serif;');
console.log('%c => GSAP', 'font-size: 14px; color: #A52A2A; font-family: "Cinzel", Arial, sans-serif;');
console.log('%cI made custom shaders for the sphere', 'font-size: 14px; color: #A52A2A; font-family: "Cinzel", Arial, sans-serif;');